import { render } from "./CourseEditSubpage.vue?vue&type=template&id=1771c39c&scoped=true"
import script from "./CourseEditSubpage.vue?vue&type=script&lang=js"
export * from "./CourseEditSubpage.vue?vue&type=script&lang=js"

import "./CourseEditSubpage.vue?vue&type=style&index=0&id=1771c39c&lang=css"
import "./CourseEditSubpage.vue?vue&type=style&index=1&id=1771c39c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1771c39c"]])

export default __exports__